import React from "react";
import useBrandTranslation from "../../hooks/useBrandTranslation";
import useInventoryOwner from "../../hooks/useInventoryOwner";
import { Label } from "../common/Label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../common/Select";

export const ownerDisplayName = (owner) =>
  [owner?.name, owner?.last_name].filter(Boolean).join(" ").trim();

// Selector "Inventario de…" para la secretaria (elige entre sus profesionales).
// Para el profesional / institución no renderiza nada. `readOnly`: solo muestra el nombre
// (en formularios, para no cambiar de inventario a mitad de una edición).
export default function InventoryOwnerSelector({ className = "", readOnly = false }) {
  const { t } = useBrandTranslation();
  const { isSecretary, owners, owner, ownerId, setOwnerId } = useInventoryOwner();

  if (!isSecretary || !owner) return null;

  return (
    <div className={`rounded-lg border border-blue-200 bg-blue-50 p-3 ${className}`}>
      <Label className="text-sm font-semibold text-gray-800">
        {t("inventory.owner.label", "Inventario de")}
      </Label>
      {readOnly || owners.length === 1 ? (
        <p className="text-sm text-gray-900 mt-1">{ownerDisplayName(owner)}</p>
      ) : (
        <Select value={ownerId || ""} onValueChange={setOwnerId}>
          <SelectTrigger className="mt-1 bg-white">
            <SelectValue placeholder={t("inventory.owner.placeholder", "Elegí un profesional")} />
          </SelectTrigger>
          <SelectContent>
            {owners.map((o) => (
              <SelectItem key={o.id} value={o.id}>
                {ownerDisplayName(o) || o.id}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
